// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1kJBO","info":"UpdateTermsInfo_info__3TYHd"};